// The Welcome board's three sample layers: bars every `step` px with a
// per-kind envelope, from the board's seeded generator (its rng() and
// wave(), ported as is) so the picture never changes and matches the board.

function rng(seed) {
  return function () {
    seed |= 0;
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

// An SVG path of vertical bars, w x h, kind "drums" | "vocal" | "bass".
export function sampleWavePath(seed, kind, w, h, step) {
  const r = rng(seed);
  const n = Math.floor(w / step);
  const mid = h / 2;
  let d = "";
  for (let i = 0; i < n; i++) {
    const p = i / n;
    let env;
    if (kind === "drums") {
      const bt = i % 8;
      env = bt === 0 ? 1 : bt === 4 ? 0.72 : 0.16 + 0.12 * r();
    } else if (kind === "bass") {
      const ph = (i % 16) / 16;
      env = 0.8 * (1 - ph) + 0.12;
    } else {
      env =
        Math.sin(p * Math.PI * 3 + seed) > -0.25
          ? 0.5 + 0.4 * r()
          : 0.05 + 0.05 * r();
    }
    const amp = Math.max(1, Math.min(1, env * (0.78 + 0.22 * r())) * (mid - 3));
    const x = (i * step + step / 2).toFixed(1);
    d += `M${x} ${(mid - amp).toFixed(1)}V${(mid + amp).toFixed(1)}`;
  }
  return d;
}

// The board's rows: you (violet) on drums, then two players.
export const SAMPLE_LAYERS = [
  { color: "var(--cl-person-1)", seed: 7, kind: "drums" },
  { color: "var(--cl-person-2)", seed: 12, kind: "vocal" },
  { color: "var(--cl-person-3)", seed: 3, kind: "bass" },
];
